var _templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  input[type=number]::-webkit-inner-spin-button,\n  input[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  box-sizing: border-box;\n\n"], ["\n  ", "\n  ", "\n  input[type=number]::-webkit-inner-spin-button,\n  input[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  box-sizing: border-box;\n\n"]);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from "react";
import styled, { ThemeProvider, createGlobalStyle } from "styled-components";
import normalizeCss from "../normalize";
import fontsExternal from "../fonts-external";
import { defaultTheme } from "../index";

var GlobalStyle = createGlobalStyle(_templateObject, normalizeCss, fontsExternal);

var Ui = styled.div.withConfig({
  displayName: "UiWeb__Ui",
  componentId: "sc-1kvjax3-0"
})(["font-family:", ";font-size:", ";color:", ";box-sizing:border-box;min-height:100vh;overflow:hidden;a{text-decoration:none;}"], function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.fontSize;
}, function (props) {
  return props.theme.textStrong;
});

var UiWeb = function UiWeb(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  return React.createElement(
    ThemeProvider,
    { theme: defaultTheme },
    React.createElement(
      React.Fragment,
      null,
      React.createElement(GlobalStyle, null),
      React.createElement(
        Ui,
        { className: className },
        children
      )
    )
  );
};

export default UiWeb;